module.exports = __webpack_public_path__ + "img/LRetroPath.b4b02386.gif";